<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
            class="float-right"
            @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>Edit Status</h3>
      <b-row>
        <b-col>
          <b-img
            v-if="formData && formData.imgURL"
            thumbnail
            fluid
            :src="formData.imgURL"
            alt="Image 3"
          />
          <div>
            {{ formData.name }}
          </div>
          <hr />
          <p>
            {{ formData.comment }}
          </p>
        </b-col>
      </b-row>
      <b-row style="margin-top: 15px;">
        <b-col>
          <b-button variant="success" block @click="handleApprove">
            Approve and Publish
          </b-button>
          <b-button variant="danger" block @click="handleReject">
            Reject
          </b-button>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import DateFormatToggle from "@/components/common/dateFormatToggle";
export default {
  name: "Admin_Manage_Sessions_UpdateStatus",
  components: {
    Modal,
    CloseButton
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  mounted() {},
  methods: {
    handleOpenStatusModalForItem(item) {
      this.entity = item;
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleApprove() {
      const updates = {
        _updated_by: this.profile && this.profile.userId,
        _approved_at: new Date(),
        status: "approved"
      };
      if (!this.entity.slug && this.entity.form.name) {
        let timeStamp = new Date().getTime();
        updates.slug = `${this.generateSlug(this.entity.form.name)}_${timeStamp}`;
      }
      this.updateStatus(updates);
    },
    handleReject() {
      const updates = {
        _updated_by: this.profile && this.profile.userId,
        _rejected_at: new Date(),
        status: "rejected"
      };
      this.updateStatus(updates);
    },
    updateStatus(updates) {
      this.$store
        .dispatch("admin/updateFormItemStatusByType", {
          id: this.entity.id,
          type: "_faves",
          updates
        })
        .then(() => {
          this.$emit('item-status-updated', updates);
          this.entity = null;
          this.$bvModal.hide(this.itemStatusModalId);
        });
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    generateSlug(string) {
      debugger;
      //Check for existing
      return string ? string.replace(/\s+/g, "-").toLowerCase() : null;
    }
  },
  data() {
    return {
      itemStatusModalId: `edit-item-status`,
      docStatus: null, //|all | submitted | needs_work | inactive
      docLevel: "doc_stage", //data, doc_stage //versions, doc_local |all | submitted | needs_work | inactive
      entity: null,
      statusOptions: [
        { value: null, text: "Please select an option" },
        { value: "submitted", text: "Submitted" },
        { value: "need_work", text: "Needs Work" },
        { value: "publish", text: "Publish" },
        { value: "republish", text: "Update Publish" },
        { value: "inactive", text: "Inactive/Remove" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
